define('presentation/settings/webChats/viewModels/addWebChatWidgetDomainViewModel',[
    'businessServices/state/modelStateObserver'
], function () {
    return function (parent) {

        const ModelStateObserverConstructor = require('businessServices/state/modelStateObserver');

        let self = this;

        self.parent = parent;

        self.modelStateObserver = null;

        self.webChatAuthorizedDomainId = '';
        self.domain = ko.observable('').extend({observeState: true});

        self.onRemoveDomainClick = () => {
            self.parent.onRemoveDomainClick(self);
        };

        const _initialize = () => {
            self.modelStateObserver = new ModelStateObserverConstructor(self, true);
            self.modelStateObserver.commitData();
        };

        _initialize();
    };
});
